import { thunk } from 'redux-thunk';
import rootReducer from '../reducers';
// Redux utility functions
import { compose, createStore, applyMiddleware } from 'redux';

export default function configureStore() {
  const composeEnhancers =
    typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
      ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
          name: 'APE LiveView',
        })
      : compose;

  const enhancer = composeEnhancers(applyMiddleware(thunk));
  return createStore(rootReducer, enhancer);
}
